import { useTranslation } from 'react-i18next';
import { ApiError, HttpStatus, QueryKeys, Role } from '@connect-x-app/shared-domain-models';
import { updateRole } from '@connect-x-app/web-data-access';
import { toastError, toastSuccess } from '@connect-x-app/web-ui';
import { useMutation, useQueryClient } from '@tanstack/react-query';

export const useUpdateRole = (onSuccess?: (data: Role) => void) => {
  const queryClient = useQueryClient();

  const { t } = useTranslation();

  return useMutation<Role, ApiError, Role>({
    mutationFn: updateRole,
    mutationKey: [QueryKeys.ROLE],
    onError: apiError => {
      if (apiError.statusCode === HttpStatus.CONFLICT) {
        toastError(`${t('ERRORS.ROLE.UPDATE.CONFLICT.TITLE')}. ${t('ERRORS.ROLE.UPDATE.CONFLICT.MESSAGE')}`);
      } else {
        toastError(t('TOAST_ERROR'));
      }
    },
    onSuccess: data => {
      queryClient.invalidateQueries({ queryKey: [QueryKeys.AUTHENTICATE] });
      queryClient.invalidateQueries({ queryKey: [QueryKeys.ROLES] });
      queryClient.invalidateQueries({ queryKey: [QueryKeys.ROLE, data.id] });

      toastSuccess(t('TOAST_SUCCESS'));

      if (typeof onSuccess === 'function') {
        onSuccess(data);
      }
    },
  });
};
